import { AI_CLOUD_ROLE, defaultConfig } from "./config.js";

//#region src/web/sdk-config.ts
const DISABLED_KEY_MARKER = "explorer";
/**
* Builds the Application Insights SDK snippet from provider options.
*
* `extensions` and `extensionConfig` are passed through by reference.
* `disableCookiesUsage` is true only for the `ux-my-prescryptive` cloud role.
*
* Pure: performs no SDK instantiation, so it is safe to call and assert on in tests.
*/
function buildSnippet({ instrumentationKey, cloudRole, extensions, extensionConfig }) {
	return { config: {
		connectionString: instrumentationKey,
		...defaultConfig,
		extensions,
		extensionConfig,
		disableCookiesUsage: cloudRole === AI_CLOUD_ROLE
	} };
}
/**
* Whether telemetry must be disabled for the given instrumentation key.
*
* True for a missing/empty key, and for any key containing `explorer`:
* Storybook injects a placeholder key (for example one containing
* "storybook-explorer") that must never reach the real SDK. Storybook's Vite
* builder can also wrap env var values in literal quotes, so the check is a
* substring match rather than equality.
*
* @param instrumentationKey - the key or connection string, if any
*/
function isTelemetryDisabled(instrumentationKey) {
	return !instrumentationKey || instrumentationKey.includes(DISABLED_KEY_MARKER);
}

//#endregion
export { buildSnippet, isTelemetryDisabled };